/**
 * 관리자 권한 유틸리티 함수
 *
 * 서버와 클라이언트 모두에서 안전하게 사용할 수 있는 관리자 권한 체크 함수입니다.
 */

/**
 * 관리자 이메일 목록 (공유)
 */
export const ADMIN_EMAILS = [
  "createyoo0491@gmail.com", // 기본/개인 관리자 계정
];

/**
 * 사용자가 관리자인지 확인하는 범용 함수
 * 서버와 클라이언트 모두에서 안전하게 사용 가능합니다.
 *
 * @param userEmail - 확인할 사용자 이메일
 * @returns 관리자 여부
 */
export function isAdminUser(userEmail: string | undefined | null): boolean {
  if (!userEmail) return false;
  return ADMIN_EMAILS.includes(userEmail);
}
